import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["_enableIconPadding", "children", "size"];
import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../MenuFooter.styles";
/**
 * @deprecated use SizeProp
 */

export var MenuFooterDataTids = {
  root: 'MenuFooter__root'
};
/**
 * Футер меню.
 *
 * _Примечание_: `футер меню`, в отличие от `элемента меню` нельзя затаргетить с клавиатуры.
 *
 * Сущности в которых может быть использован `MenuFooter`: [DropdownMenu](#/Components/DropdownMenu), [Kebab](#/Components/Kebab), [TooltipMenu](#/Components/TooltipMenu) и [Select](#/Components/Select).
 */

function MenuFooter(_ref) {
  var _cx;

  var _ref$_enableIconPaddi = _ref._enableIconPadding,
      _enableIconPadding = _ref$_enableIconPaddi === void 0 ? false : _ref$_enableIconPaddi,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var theme = useContext(ThemeContext);

  function getRootSizeClassName() {
    switch (size) {
      case 'large':
        return styles.rootLarge(theme);

      case 'medium':
        return styles.rootMedium(theme);

      case 'small':
      default:
        return styles.rootSmall(theme);
    }
  }

  function getWithLeftPaddingSizeClassName() {
    switch (size) {
      case 'large':
        return styles.withLeftPaddingSmall(theme);

      case 'medium':
        return styles.withLeftPaddingMedium(theme);

      case 'small':
      default:
        return styles.withLeftPaddingSmall(theme);
    }
  }

  return /*#__PURE__*/React.createElement(CommonWrapper, rest, /*#__PURE__*/React.createElement("div", {
    "data-tid": MenuFooterDataTids.root,
    className: cx(getRootSizeClassName(), (_cx = {}, _cx[styles.root(theme)] = true, _cx[getWithLeftPaddingSizeClassName()] = _enableIconPadding, _cx))
  }, children));
}

MenuFooter.__KONTUR_REACT_UI__ = 'MenuFooter';
MenuFooter.displayName = 'MenuFooter';
MenuFooter.__MENU_FOOTER__ = true;
export { MenuFooter };
export var isMenuFooter = function isMenuFooter(child) {
  return /*#__PURE__*/React.isValidElement(child) ? Object.prototype.hasOwnProperty.call(child.type, '__MENU_FOOTER__') : false;
};